import React from "react";
import ReactDOM from "react-dom/client";
import { PostHogProvider } from "posthog-js/react";
import "./index.css";
import App from "./App";

const posthogKey = import.meta.env.VITE_PUBLIC_POSTHOG_KEY;
const isProduction = import.meta.env.PROD;
const shouldInitializePostHog = isProduction && posthogKey;

// Use reverse proxy path (/ingest) to bypass ad blockers
// - Production: Goes through Caddy reverse proxy
// - Development: Goes through Vite dev server proxy
const posthogHost = "/ingest";

const posthogOptions = {
  api_host: posthogHost,
  ui_host: "https://us.posthog.com", // Required for toolbar links
  debug: false, // Disable debug in production
  autocapture: true,
  capture_pageview: false, // We handle SPA pageviews manually
  capture_pageleave: true,
  session_recording: {
    maskAllInputs: true,
    maskInputOptions: {
      password: true,
    },
    maskTextSelector: "[data-posthog-mask]",
  },
};

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <React.StrictMode>
    {shouldInitializePostHog ? (
      <PostHogProvider apiKey={posthogKey} options={posthogOptions}>
        <App />
      </PostHogProvider>
    ) : (
      <App />
    )}
  </React.StrictMode>
);
